export default __webpack_public_path__ + "static/media/12.9ff1ef1e.png";